import PropTypes from "prop-types"
import { Person } from "@mui/icons-material"
import { connect } from "react-redux"
import { get } from "lodash"
import Header from "modules/home-header"

function MemberResourcesHeader({ account, name }) {
  const memberName = name ? `Member Permissions: ${name}` : "Member Permissions"
  return <Header Icon={Person} title={memberName} account={account} />
}

MemberResourcesHeader.propTypes = {
  account: PropTypes.string.isRequired,
  name: PropTypes.string,
}

export default connect(state => ({ name: get(state, "global.data.memberPermissions.data.member.name") }), null)(MemberResourcesHeader)
